/* eslint-disable import/prefer-default-export */
import EntryActionTypes from '../../constants/EntryActionTypes';

export const rebootSystem = () => ({
  type: EntryActionTypes.REBOOT_SYSTEM,
  payload: {},
});
